// extracted by mini-css-extract-plugin
export default {"link":"PersonLinkBack_link__afdJG","link__img":"PersonLinkBack_link__img__DAo8U"};